import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, X } from "lucide-react";
import { Button } from "components/ui/button";
import TextInput from "components/app/function/TextInput";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { AppLog } from "services";
import DatePicker from "components/app/function/DatePicker";
import { useState } from "react";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { SkeletonPublicHoliday } from "components/app/shrimmer/Shrimmer";
import DatePickerInput from "components/app/function/DatePickerInput";
interface DialogProps {
  setOpenDrawerPulicHoliday: any;
  publicHolidays: any;
  setPublicHolidays: any;
  loadigGetpublicHolidays: any;
}
export default function PublicHoliday({ setOpenDrawerPulicHoliday, publicHolidays, setPublicHolidays, loadigGetpublicHolidays }: DialogProps) {
  const location = useLocation();
  const { token } = useAppSelector((state) => state.auth);
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [loadingSubmitHoliday, setLoadingSubmitHoliday] = useState<boolean>(false);

  function handlePublicHolidays(index: number, field: string, value: any) {
    if (value == null) return; // or set to ""
    setPublicHolidays((prev: any) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });
  }

  const submitShopPublicHoliday = async () => {
    setLoadingSubmitHoliday(true);
    try {
      const url = `${RouteApi.submitShopPublicHoliday}token=${token}`;
      const data = {
        shop_id: shopId,
        records: publicHolidays,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setPublicHolidays(response.public_holidays);
        setOpenDrawerPulicHoliday(null);
        setLoadingSubmitHoliday(false);
      } else {
        setLoadingSubmitHoliday(false);
      }
    } catch (error) {
      setLoadingSubmitHoliday(false);
      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  return (
    <>
      <div>
        <div className=" max-w-[1300px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <div>
            <div className="flex items-center justify-between ">
              <div className="flex flex-col  absolute left-3 top-[12px]  ">
                <div className="font-bold">Public Holiday</div>
                <div>Government-Declared Days Off, Recognized National and Cultural Holidays.</div>
              </div>
            </div>
            <div
              className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 border border-gray-300 "
              onClick={() => {
                setOpenDrawerPulicHoliday(null);
              }}
            >
              <X />
            </div>
          </div>
          <ScrollArea className="mt-2 w-full gap-3  pr-[20px] mb-[50px]">
            {loadigGetpublicHolidays ? (
              <SkeletonPublicHoliday />
            ) : (
              <>
                <div className="mt-2 gap-3 overflow-hidden overscroll-auto ">
                  <table className="min-w-full border-collapse mb-20  overflow-hidden">
                    <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-50 dark:bg-[#2c3a52] dark:text-gray-400">
                      <tr className="border text-[16px] text-start">
                        <th className=" py-5 border  ">No. </th>
                        <th className="px-4 py-5 border  ">Description </th>
                        <th className="px-4 py-5 border w-[100px]">Starting Date</th>
                        <th className="px-4 py-5 border  w-[100px]">Ending Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {publicHolidays?.map((item: any, index: number) => {
                        console.log("item.starting_date from parent", item.starting_date);
                        return (
                          <tr key={index} className="text-center">
                            <td className="p-1 text-md border">{index + 1}</td>
                            <td className="p-1 text-md border">
                              <TextInput
                                value={item.description}
                                className="w-full h-full border-none py-4 rounded-none bg-transparent text-start focus:border-none text-[16px]"
                                onChange={(e) => handlePublicHolidays(index, "description", e.target.value)}
                              />
                            </td>
                            <td className=" text-md border">
                              <DatePickerInput
                                border=" border-none "
                                placeholder=""
                                className="py-5 h-full border-none w-[100px] rounded-none border-gray-300 text-[15px] "
                                onChange={(value: any) => {
                                  console.log("startingDate====:", value);

                                  handlePublicHolidays(index, "starting_date", value);
                                }}
                                value={item.starting_date}
                              />
                            </td>
                            <td className=" text-md border">
                              <DatePickerInput
                                border=" border-none "
                                placeholder=""
                                className="py-5 h-full border-none w-[100px] rounded-none border-gray-300 text-[15px] "
                                onChange={(value: any) => {
                                  handlePublicHolidays(index, "ending_date", value);
                                }}
                                value={item.ending_date}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            <ScrollBar orientation="vertical" />
          </ScrollArea>
          <ScrollBar orientation="vertical" />
          <div className="flex justify-end items-center gap-4 fixed bottom-3 py-5 right-2 bg-white dark:bg-[#020817]">
            <div className="flex gap-2">
              <Button
                className="px-5 dark:text-white me-5"
                onClick={() => {
                  submitShopPublicHoliday();
                }}
              >
                {loadingSubmitHoliday ? <Loader className="animate-spin" /> : "Save"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
